export default "__VITE_ASSET__BCCibwD6__"